import { useEffect, useState,useRef } from "react";
import Slider from "react-slick";
import { getAllExperts,getAllZones } from "../../services/kojaServices";
import { downloadUrl } from "../../confing/confing";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";

const Experts = () => {
  const [experts, setExperts] = useState([]);
  const [zones,setZones] = useState([]);
  const [zonesId,setZonesId] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getAllExperts(zonesId);
        setExperts(data.result.rows);
        const { data:zones } = await getAllZones();
        setZones(zones.result)
      } catch (err) {
        console.log(err);
        toast.error("خطایی رخ داده است، مجدد تلاش کنید")
      }
    };
    fetchData();
  }, [zonesId]);

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, []);

  let slider1 = useRef(null);
  let slider2 = useRef(null);

  const settings = {
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    rtl: true,
    nextArrow: <p></p>,
    prevArrow: <p></p>,
  };

  const settings2 = {
    customPaging: function(i) {
      return (
        <div className="">
        </div>
      );
    },
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    rows:1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    rtl: true,
    nextArrow:<SampleArrow/>,
    prevArrow:<SampleArrow/>
  };
  function SampleArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
      ></div>
    );
  }
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, position:"absolute",top:"-20px", left:"45%", transform:"rotate(90deg)" }}
        onClick={onClick}
      />
    );
  }
  function SampleprevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, position:"absolute",top:"102%", left:"48%", transform:"rotate(90deg)" }}
        onClick={onClick}
      />
    );
  }

  const zonesSettings = {
    customPaging: function(i) {
      return (
        <div className="">
        </div>
      );
    },
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    nextArrow: <SampleNextArrow/>,
    prevArrow: <SampleprevArrow/>
  };

  return (
    <div className="koja-experts justify-content-center justify-content-md-start">
      <div
        className="black-strip2 d-none d-md-flex justify-content-center align-items-center"
        style={{ marginRight: "75px" }}
      >
        <div className="experts-cities-box">
        <Slider className=""  {...zonesSettings}>
        {
          zones.map((i,index)=> (
            <button className="btn experts-cities-item mt-3 " key={index} onClick={()=>{setZonesId(i.id)}}>{i.name}</button>
          ))
        }
      </Slider>
        </div>
      </div>
      <div className="experts-box m-auto" >
        <div className="d-none d-md-block">
          <h2>کارشناسان کجا</h2>
        </div>
        <div className="mb-3 d-md-none">
        <Slider className=""  {...settings2}>
        {
          zones.map((i,index)=> (
            <button className="btn experts-cities-item mt-3 " key={index} onClick={()=>{setZonesId(i.id)}}>{i.name}</button>
          ))
        }
      </Slider>
        </div>
        <div className="koja-experts-box">
          <div className="koja-experts-item-box">
            <Slider {...settings}
            asNavFor={nav2} ref={slider => (slider1 = slider)}
            >
              {experts.map((i, index) => (
                <div key={index} style={{textAlign:"right"}}>
                  <img
                    alt=""
                    className="koja-experts-item-img"
                    src={`${downloadUrl}${i.pic}`}
                  />
                  <div className="koja-experts-item-content">
                    <strong>{i.name}</strong>
                    <div className="text-end  mt-2 ms-3 me-3">
                      <strong>نام دفتر : </strong>
                      <p className="d-inline"> {i.agencyName} </p>
                    </div>
                    <div className="text-end  mt-2 ms-3 me-3">
                      <strong>آدرس دفتر : </strong>
                      <p className="d-inline">
                        {" "}
                        {i.agencyAddress.substring(0, 100)}
                      </p>
                    </div>
                    <div className="text-end  mt-2 ms-3 me-3">
                      <strong>شماره تماس : </strong>
                      <p className="d-inline"> {i.agencyTel}</p>
                    </div>
                    <div className="expert-login-btn-box">
                    <Link to='userlogin'>
                    <button className="btn expert-login-btn text-nowrap">درخواست کارشناسی</button>
                    </Link>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="experts-list-box">
        <Slider 
        asNavFor={nav1}
        ref={slider => (slider2 = slider)}
        slidesToShow={experts.length > 5 ? 5 : experts.length}
        swipeToSlide={true}
        focusOnSelect={true}
        >
        {experts.map((i, index) => (
          <div key={index}>
            <img
              alt=""
              className="experts-list-img"
              src={`${downloadUrl}${i.pic}`}
            />
          </div>
        ))}
        </Slider>
        </div>
      </div>
    </div>
  );
};

export default Experts;
